import { useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";

export default function FloatingTools() {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  function protectedNavigate(path) {
    if (isAuthenticated) {
      navigate(path);
      return;
    }

    navigate(`/login?next=${encodeURIComponent(path)}`);
  }

  function openMessages() {
    // TAZY protected communication.
    // Buyers and sellers communicate through marketplace enquiries,
    // keeping communication attached to real marketplace activity.
    protectedNavigate("/portal/enquiries");
  }

  function openAiSupport() {
    protectedNavigate("/portal/ai");
  }

  function openScan() {
    navigate("/scan");
  }

  function openHelp() {
    navigate("/buyer-help");
  }

  return (
    <div className="floating-tools" aria-label="Quick tools">
      <button
        type="button"
        title="Messages"
        aria-label="Open protected TAZY messages"
        onClick={openMessages}
      >
        ▣
      </button>

      <button
        type="button"
        title="TAZY AI"
        aria-label="Open TAZY AI"
        onClick={openAiSupport}
      >
        A
      </button>

      <button
        type="button"
        title="Scan"
        aria-label="Search TAZY CART using a product photo"
        onClick={openScan}
      >
        ⌖
      </button>

      <button
        type="button"
        title="Help"
        aria-label="Open TAZY Help Centre"
        onClick={openHelp}
      >
        ?
      </button>

      <button
        type="button"
        title="Top"
        aria-label="Back to top"
        onClick={() =>
          window.scrollTo({ top: 0, behavior: "smooth" })
        }
      >
        ↑
      </button>
    </div>
  );
}
